/**
 * Canonical gate for the Query-fed Item Pools module (Large Sets PRD §4.3).
 *
 * Resolves Entitlement → Workspace module → Module policy → Personal flag via
 * the one policy-aware gate (build contract §2.7). Never check
 * isModuleEnabled/isFeatureEnabled inline for feed surfaces — use this.
 */

import { useModuleGate } from '../../../lib/moduleGate';

export function useQueryFedPoolsEnabled(): boolean {
  return useModuleGate('query_fed_pools');
}
